// import { API_BASE_URL } from './api';
import {api} from './api'

const getProperties = async (userId) => {
    const response = await api.get(`/user/${userId}/properties`)
    return response.data;
}

const getProspects = async ( propertyId) => {
    const response = await api.get(`/user/${propertyId}/prospects`);
    return response.data;
}

const getProspect = async (userId, prospectId) => {
    const response = await api.get(`/user/${userId}/prospects/${prospectId}`);
    return response.data;
}

const createProspect = async (userId, propertyId, name, phone) => {
    const response = await api.post(`/user/properties/${propertyId}/prospect/new`, {name, phone })
      return response.data;
}

export { getProperties, getProspects, getProspect, createProspect };